import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.tsx';
import LoadingSpinner from './LoadingSpinner.tsx';

interface CustomerRouteProps {
  children: ReactNode;
}

const CustomerRoute: React.FC<CustomerRouteProps> = ({ children }) => {
  const { isAuthenticated, isCustomer, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner size="lg" text="Loading..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Ensure only customers can access customer routes
  if (!isCustomer) {
    console.warn('Non-customer user attempted to access customer route');
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};

export default CustomerRoute;
